const video = document.getElementById('topMovie');
const muteButton = document.getElementById('muteButton');

muteButton.addEventListener('click', () => {
    if (video.muted) {
        video.muted = false; // ミュート解除
        muteButton.src = "https://cdn.shopify.com/s/files/1/0622/7279/8907/files/mute_on.png?v=1728798180"; // ミュート解除画像に変更
    } else {
        video.muted = true; // ミュート
        muteButton.src = "https://cdn.shopify.com/s/files/1/0622/7279/8907/files/mute_off.png?v=1728798180";; // ミュート画像に変更
    }
});
